import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  text: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
})

const TimeAtHomeChartHelpIcon: FC = () => {
  const classes = useStyles()
  return (
    <Tooltip
      title={
        <Typography variant="body1" className={classes.text}>
          Proportion of time spent home vs. out of the home each day. Calculated
          throughout the first 7 days of using Vira and based on primary
          location during sleep periods. Your client must move 100 meters for
          Vira to detect movement out of the home. Time at home can be a
          predictor of mental health.
        </Typography>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}

export default TimeAtHomeChartHelpIcon
